import { useEffect } from "react";

const DEFAULT_TITLE = "ExactReach — Targeted B2B data on demand";
const DEFAULT_DESC = "Describe your audience in plain English. Receive an estimate and 20-row sample. Pay only for the data you need. No subscription.";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SEO({ title, description, path, noindex = false }) {
  useEffect(() => {
    const finalTitle = title ? `${title} · ExactReach` : DEFAULT_TITLE;
    const finalDesc = description || DEFAULT_DESC;
    document.title = finalTitle;
    setMeta("description", finalDesc);
    setMeta("og:title", finalTitle, "property");
    setMeta("og:description", finalDesc, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:url", window.location.href, "property");
    setMeta("twitter:card", "summary");
    setMeta("twitter:title", finalTitle);
    setMeta("twitter:description", finalDesc);
    setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, path, noindex]);
  return null;
}
